module.exports = "span{\r\n    color: #0000EE;\r\n    cursor: pointer;\r\n    text-decoration: underline;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/resource-url/resource-url.component.css
// module id = ./src/app/resource-url/resource-url.component.css
// module chunks = main